import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import { pathname } from '../../utils/path/path';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 600,
  },
  header: { fontSize: 50, marginBottom: 0, marginTop: 0 },
  description: {
    fontSize: '1.4em',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  button: { fontSize: '1.4em', minWidth: 175 },
  icon: { fontSize: theme.spacing(20), color: theme.palette.primary.main },
  applicationName: { fontSize: '1.5em' },
}));

export default function Success() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <FontAwesomeIcon icon={faPaperPlane} className={classes.icon} />
        <div className={classes.description}>
          <h3> We're on it. Hang tight!</h3>
          <Typography>We’ve received your request.</Typography>
          <Typography>
            It will take up to 72 hours until you receive <br />
            your custom Growth plan, but trust us - it's worth it.
          </Typography>
        </div>
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          onClick={() => history.push(pathname.dashboard.url)}
        >
          Go to My Dashboard
        </Button>
      </div>
    </div>
  );
}
